/**
 * 企画回別商品一覧画面のサイクル情報登録クラス
 *
 * @export RegistCycleInfo
 * @class RegistCycleInfo
 */
export class RegistCycleInfo {
  constructor(
    public orderCode: string,
    public mediumType: string,
    public buyerCode: string,
    public registCycleInfoList: RegistCycleInfoList[],
  ) {}
}

export class RegistCycleInfoList {
  constructor (
    public pCode: string,
    public itemCode: string,
    public specialFeature: string,
    public orderNumQuotaCode: string,
    public mediumWPublishFlg: string,
    public crossDecisionFlg: string,
    public crossCode: string,
    public pricePromotion: string,
    public komaPromotion: string,
    public promotionMark: string,
  ) {}
}